module.exports = __webpack_public_path__ + "img/nothing.5996a68c.png";